import * as Sentry from '@sentry/react';
import { ENV, SENTRY_DSN, BUILD_NAME, IS_PROD } from 'settings';
import ApiErrorV2 from 'v2/errors/api';

import { ApiError } from './apiError';
import { errorMessageFormatter } from './errorMessage';

let sentrySetup = false;

if (SENTRY_DSN) {
  Sentry.init({
    sampleRate: 0.25,
    dsn: SENTRY_DSN,
    environment: ENV,
    release: getRelease(),
    ignoreErrors: [
      'Network Error',
      'Request aborted',
      /Request failed with status code .*/,
      'timeout of 0ms exceeded',
      'SecurityError: The operation is insecure.',
      'api-error',
      'ApiError',
      "Cannot read property 'offsetWidth' of null",
      "null is not an object (evaluating 'n.offsetLeft')",
      'Use ServiceWorkerRegistration.show"Notification() instead',
      "Can't find variable: Notification",
      'Access is denied for this document',
      'O campo script é obrigatório',
      'Cliente não encontrado',
    ],
    beforeSend: (event, hint) => {
      if (hint?.originalException instanceof ApiErrorV2 || hint?.originalException instanceof ApiError) {
        return null;
      }
      return event;
    },
  });

  sentrySetup = true;
}

export const setUser = (user: any) => {
  Sentry.setUser({ id: user.id });
};

export const clearUser = () => {
  Sentry.configureScope((scope) => scope.setUser(null));
};

export function addBreadcrumb(message: string, category: string = 'manual', data: any = {}): void {
  data = data || {};
  delete data.type;

  sentrySetup && Sentry.addBreadcrumb({ message, category, data });
}

export function logError(err: any): void {
  sentrySetup && Sentry.captureException(err, { extra: err.extraData });
  let error = null;

  /*
    TODO:
    o trecho abaixo foi desenvolvido para corrigir a
    falta de padronização dos retorno de erros da API.

    29/08/2019 15:05
  */

  if (err?.data?.message && typeof err.data.message === 'string') {
    error = err.data.message;
  }

  if (err?.data?.data?.message?.error) {
    error = err.data.message.error;
  }

  if (!error && err?.data?.message?.error) {
    error = err.data.message.error;
  }

  if (error && typeof error === 'object') {
    for (let prop in error) {
      error = error[prop];
    }
  }

  if (!error || typeof error !== 'string') {
    error = errorMessageFormatter(err);
  }

  throw error;
}

export function logComponentError(err: any): void {
  sentrySetup && Sentry.captureException(err, { extra: err.extraData });
}

function getRelease() {
  if (!IS_PROD) return null;
  return `orbita@${BUILD_NAME}`;
}
